export const version = "wallet/5.8.0";
